import { Component, OnInit } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateNumberComponent } from "../../templates/template-number/template-number.component";
import { Max } from "../../types/Max";
import { Min } from "../../types/Min";

@Component({
  standalone: true,
  selector: "app-prefix-be3",
  imports: [TemplateNumberComponent],
  templateUrl: "./prefix-be3.component.html",
  styleUrl: "./prefix-be3.component.less",
})
export class PrefixBe3Component extends PrefixComponent<string> implements OnInit {
  public max: Max;
  public min: Min;
  public commas: number;

  public constructor() {
    super({ updateOn: "blur" });
    this.max = 9999999.99;
    this.min = 0.01;
    this.required = true;
    this.commas = 2;
    this.characters = ALLOWED_CHARACTERS["be3"];
  }
}
